/* Main gallery navigation arrows.
   Rather than reimplementing slide navigation, this drives the theme's own
   thumbnail-switching: each thumbnail <li> carries data-target and a <button>
   that media-gallery.js already listens on to swap the active media. Clicking
   our overlay arrow just finds the next/previous thumbnail and clicks it. */
(function () {
  function thumbItems(gallery) {
    var thumbs = gallery.querySelector('[id^="GalleryThumbnails-"]');
    if (!thumbs) return [];
    return [].slice.call(thumbs.querySelectorAll('[data-target]'));
  }

  function activeIndex(items) {
    for (var i = 0; i < items.length; i++) {
      var btn = items[i].querySelector('button');
      if (btn && btn.getAttribute('aria-current') === 'true') return i;
    }
    return 0;
  }

  function go(gallery, dir) {
    var items = thumbItems(gallery);
    if (items.length < 2) return;
    var idx = activeIndex(items);
    var newIdx = idx + dir;
    if (newIdx < 0 || newIdx > items.length - 1) return; // no wrap — the end is the end
    var target = items[newIdx].querySelector('button');
    if (target) target.click();
  }

  // No arrow at the first image (nowhere to go back to) or the last (nowhere
  // forward). Re-run on every active-media change, not just our own clicks —
  // swiping or clicking a thumbnail directly should keep the arrows in sync too.
  function updateDisabled(nav, gallery) {
    var items = thumbItems(gallery);
    if (!items.length) return;
    var idx = activeIndex(items);
    var prev = nav.querySelector('[data-ai-gnav-prev]');
    var next = nav.querySelector('[data-ai-gnav-next]');
    if (prev) prev.disabled = idx <= 0;
    if (next) next.disabled = idx >= items.length - 1;
  }

  function init(nav) {
    if (nav.getAttribute('data-ai-gnav-ready')) return;
    nav.setAttribute('data-ai-gnav-ready', '1');
    var gallery = nav.closest('media-gallery');
    if (!gallery) return;
    var prev = nav.querySelector('[data-ai-gnav-prev]');
    var next = nav.querySelector('[data-ai-gnav-next]');
    if (prev) prev.addEventListener('click', function (e) { e.preventDefault(); go(gallery, -1); updateDisabled(nav, gallery); });
    if (next) next.addEventListener('click', function (e) { e.preventDefault(); go(gallery, 1); updateDisabled(nav, gallery); });

    updateDisabled(nav, gallery);
    var thumbs = gallery.querySelector('[id^="GalleryThumbnails-"]');
    if (thumbs && window.MutationObserver) {
      new MutationObserver(function () { updateDisabled(nav, gallery); })
        .observe(thumbs, { attributes: true, attributeFilter: ['aria-current'], subtree: true });
    }
  }

  function boot() {
    var navs = document.querySelectorAll('[data-ai-gnav]');
    for (var i = 0; i < navs.length; i++) init(navs[i]);
  }

  if (document.readyState !== 'loading') { boot(); }
  else { document.addEventListener('DOMContentLoaded', boot); }
  document.addEventListener('shopify:section:load', boot);
})();
